import { FaChevronLeft } from 'react-icons/fa';
import {
  Bs2CircleFill,
  Bs3CircleFill,
  BsCheckCircleFill,
} from 'react-icons/bs';

interface NavbarMobileProps {
  orderState: number;
  handlePrevState: () => void;
}

const NavbarMobile = ({ orderState, handlePrevState }: NavbarMobileProps) => {
  const navbarText = () => {
    switch (orderState) {
      case 0:
        return 'Website';
      case 1:
        return 'Website';
      case 2:
        return 'Add ons';
      case 3:
        return 'Contact Info';
      default:
        return 'Website';
    }
  };

  const progress = () => {
    switch (orderState) {
      case 0:
        return 'w-1/3';
      case 1:
        return 'w-1/3';
      case 2:
        return 'w-2/3';
      case 3:
        return 'w-full';
      default:
        return 'w-1/3';
    }
  };

  return (
    <div
      className={`flex items-center border-b border-[#F0F3F7] px-[60px] pl-4 lg:hidden ${
        orderState >= 4 ? 'py-[18px]' : 'py-3'
      }`}
    >
      <button
        className="flex h-6 w-6 items-center justify-center"
        onClick={handlePrevState}
      >
        <FaChevronLeft color="#AAB4C8" className="text-xl" />
      </button>
      {orderState <= 3 ? (
        <div className="ml-4 w-full">
          <p className="text-base font-semibold text-black">{navbarText()}</p>
          <div className="flex items-center">
            <p className="text-xs font-bold text-primary-light-blue">
              {orderState === 1 || orderState === 0 ? '1' : orderState}/3
            </p>
            <div className="ml-1.5 h-1.5 w-full rounded-full bg-tertiary-light-blue">
              <div
                className={`h-1.5 rounded-full bg-primary-light-blue ${progress()}`}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="ml-4 flex w-full items-center justify-between">
          <div className="flex items-center">
            <BsCheckCircleFill color="#000" />
            <p className="ml-1.5 text-sm text-primary-black">Order</p>
          </div>

          <div className="w-4 border border-tertiary-light-blue" />

          <div className="flex items-center">
            {orderState >= 5 ? (
              <BsCheckCircleFill color="#000" />
            ) : (
              <Bs2CircleFill color="#000" />
            )}
            <p className="ml-1.5 text-sm text-primary-black">Review</p>
          </div>

          <div className="w-4 border border-tertiary-light-blue" />

          <div className="flex items-center">
            <Bs3CircleFill
              color={
                orderState === 5 ? '#000' : '#AAB4C8'
              }
            />
            <p
              className={`ml-1.5 text-sm ${
                orderState === 5 ? 'text-primary-black' : 'text-tertiary-grey'
              }`}
            >
              Pay
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default NavbarMobile;
